import {
  Box,
  Card,
  CardContent,
  Grid,
  Skeleton,
  Typography,
} from "@mui/material";
import React from "react";
import GraphCard from "../IncimanDashboard/Components/GraphCard";
import ManIcon from "@mui/icons-material/Man";
import { getColorByCount } from "../../utils/getGraphColor";

const Graphs = ({ data, loading }) => {
  if (loading) {
    return (
      <>
        <Grid container sx={{ marginTop: 3 }} spacing={1}>
          <Grid item xl={4} lg={4} sm={12} xs={12}>
            <Skeleton variant="rectangular" height={600} />
          </Grid>
          <Grid item xl={8} lg={8} sm={12} xs={12} sx={{ height: 600 }}>
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: 25,
              }}
            >
              Investigation
            </Typography>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Skeleton variant="rectangular" height={280} />
              </Grid>
              <Grid item xs={6}>
                <Skeleton variant="rectangular" height={280} />
              </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ marginTop: 1 }}>
              <Grid item xs={4}>
                <Skeleton variant="rectangular" height={250} />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant="rectangular" height={250} />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant="rectangular" height={250} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={1} marginTop={1}>
          <Grid item xl={4} lg={4} sm={12} xs={12}>
            <Skeleton variant="reactangular" height={250} />
          </Grid>
          <Grid item xl={4} lg={4} sm={12} xs={12}>
            <Skeleton variant="reactangular" height={250} />
          </Grid>
          <Grid item xl={4} lg={4} sm={12} xs={12}>
            <Skeleton variant="reactangular" height={250} />
          </Grid>
        </Grid>
      </>
    );
  }
  return (
    <>
      <Grid container sx={{ marginTop: 3 }} spacing={1}>
        <Grid item xl={4} lg={4} sm={12} xs={12}>
          <GraphCard
            title="Incident by Regional / Subsidiaries"
            data={data.incidentByRegion}
            type="barHorizontal"
            style={{ height: 600 }}
          />
        </Grid>
        <Grid item xl={8} lg={8} sm={12} xs={12} sx={{ height: 600 }}>
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: 25,
              marginBottom: 1,
            }}
          >
            Investigation
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <GraphCard
                title="Incident by Fleet"
                data={data.incidentByFleet}
                type="barHorizontal"
                style={{ height: 280 }}
              />
            </Grid>
            <Grid item xs={6}>
              <GraphCard
                title="Incident Cause"
                data={data.incidentCause}
                type="barHorizontal"
                style={{ height: 280 }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ marginTop: 1 }}>
            <Grid item xs={4}>
              <GraphCard
                title="Incident Type"
                data={data.incidentType}
                type="doughnutPercentage"
                style={{ height: 185 }}
              />
            </Grid>
            <Grid item xs={4}>
              <GraphCard
                title="Incident Severity"
                data={data.incidentSeverity}
                type="doughnutPercentage"
                style={{ height: 185 }}
              />
            </Grid>
            <Grid item xs={4}>
              <GraphCard
                title="Incident Time"
                data={data.incidentTime}
                type="doughnutPercentage"
                style={{ height: 185 }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={1} marginTop={1}>
        <Grid item xl={4} lg={4} sm={12} xs={12}>
          <Card sx={{ paddingTop: 1 }}>
            <Typography
              sx={{
                fontSize: 17,
                textAlign: "center",
                margin: "0 8px",
              }}
            >
              Injured Person Status
            </Typography>
            <CardContent>
              <Box
                sx={{
                  height: 180,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 1,
                }}
              >
                <Grid container spacing={1}>
                  {data?.injuredPersonStatus?.length === 1 ? (
                    <div
                      style={{
                        display: "flex",
                        flex: 1,
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                        }}
                      >
                        <div>
                          <ManIcon
                            sx={{
                              fontSize: 70,
                              color: getColorByCount(1)[0],
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: 14,
                              textAlign: "center",
                            }}
                          >
                            {data?.injuredPersonStatus[0].groupName}
                          </Typography>
                        </div>
                        <Typography
                          sx={{
                            fontSize: 50,
                            fontWeight: "bold",
                          }}
                        >
                          {data?.injuredPersonStatus[0].countData}
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    data?.injuredPersonStatus?.map((item) => (
                      <Grid
                        item
                        xs={6}
                        key={item.id}
                        sx={{ textAlign: "center" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                          }}
                        >
                          <div>
                            <ManIcon
                              sx={{
                                fontSize: 70,
                                color: getColorByCount(
                                  data?.injuredPersonStatus?.length
                                )[item.id - 1],
                              }}
                            />
                            <Typography sx={{ fontSize: 14 }}>
                              {item.groupName}
                            </Typography>
                          </div>
                          <Typography sx={{ fontSize: 50, fontWeight: "bold" }}>
                            {item.countData}
                          </Typography>
                        </div>
                      </Grid>
                    ))
                  )}
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xl={4} lg={4} sm={12} xs={12}>
          <GraphCard
            title="Incident By Month"
            data={data?.incidentByMonth?.sort((a, b) => a.id - b.id)}
            type="line"
          />
        </Grid>
        <Grid item xl={4} lg={4} sm={12} xs={12}>
          <GraphCard
            title="Investigation Status"
            type="gauge"
            gaugeValue={data?.investigationStatus}
            gaugeNeedleBasedOn="height"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Graphs;
